import { useQueryClient } from "@tanstack/react-query";

import { ReviewItemFieldsFragment, useDeleteReportCommentMutation } from "@api/graphql/types-and-hooks";
import { invalidateReviewItems, settleReviewMutation } from "@components/QaReview/hooks/reviewMutations";
import { notifyError } from "@components/notifications/notifications";

export const useDeleteComment = () => {
  const queryClient = useQueryClient();
  const { mutate, isPending } = useDeleteReportCommentMutation({
    onSuccess: async (data) => {
      if (settleReviewMutation(data?.deleteReportComment, { failure: "Failed to delete comment" })) {
        await invalidateReviewItems(queryClient);
      }
    },
    onError: () => notifyError("Error deleting comment. Please try again."),
  });

  const remove = (comment: ReviewItemFieldsFragment, onSettled: () => void) =>
    mutate({ id: comment.id }, { onSettled });

  return { remove, isPending };
};
